export { };

declare global {
  interface String {
    /**
     * Tenta converter a string para número
     */
    toNumber(): number;

    /**
     * Formata a string para uma moeda
     */
    toCurrency(locale?: string, currency?: string): string;
  }

  interface Number {
    /**
     * Formata o número para uma moeda
     */
    toCurrency(locale?: string, currency?: string): string;
    /**
     * Tenta arredondar para cima, de 5 em 5 centavos, mantendo o máximo de 2 casas decimais.
     */
    roundCurrency(): number;
    /**
     * Converte um valor de decimal/inteiro para centavos
     */
    toCurrencyCents(): number;
  }
}

String.prototype.toNumber = function (): number {
  const value = this.valueOf(); // Obtém a string atual
  const int = parseInt(value, 10);
  const float = parseFloat(value);

  // Verifica se a string é um inteiro
  if (!isNaN(int) && int.toString() === value) {
    return int;
  }

  // Verifica se a string é um número de ponto flutuante
  if (!isNaN(float) && float.toString() === value) {
    return float;
  }

  // Adicionalmente, verificamos se a string é um float que pode ter zeros à direita
  if (!isNaN(float) && value.includes('.') && parseFloat(value).toString() === parseFloat(parseFloat(value).toFixed(10)).toString()) {
    return float;
  }

  return NaN;
};

String.prototype.toCurrency = function (locale: string = 'pt-BR', currency: string = 'BRL'): string {
  const number = this.toNumber();
  if (isNaN(number)) return 'Invalid number';
  return number.toLocaleString(locale, { style: 'currency', currency });
};

Number.prototype.toCurrency = function (locale: string = 'pt-BR', currency: string = 'BRL'): string {
  return this.toLocaleString(locale, { style: 'currency', currency });
};

Number.prototype.roundCurrency = function (): number {
  const value = this as number;

  // Arredondar para cima para o próximo múltiplo de 0.05
  const rounded = Math.ceil(value * 20) / 20;

  // Garantir no máximo 2 casas decimais
  return parseFloat(rounded.toFixed(2));
};

Number.prototype.toCurrencyCents = function (): number {
  const value = this as number;

  // Converte o valor para centavos, arredondando para evitar problemas de precisão
  return Math.round(value * 100);
};
